<div class="content">
  <div class="image">
    <pub-card-image [entryId]="conceptId" [fileIds]="fileIds"></pub-card-image>
  </div>
  @for (field of displayFields; track field.oid) {
    <div>
      <div pub-field-render [field]="field" (conceptSelected)="selectConcept($event)"></div>
    </div>
  }
</div>
